import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NavbarComponent } from './components/layouts/navbar/navbar.component';
import { PreloaderComponent } from './components/layouts/preloader/preloader.component';
import { FooterComponent } from './components/layouts/footer/footer.component';
import { ChattingComponent } from './components/common/chatting/chatting.component';
import { HttpClientModule } from '@angular/common/http';
import { BsDatepickerModule, BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { AgmCoreModule } from '@agm/core';
import { MatTableModule } from "@angular/material/table";
import { MatSortModule } from '@angular/material/sort';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatChipsModule } from '@angular/material/chips';

import { HomeComponent } from './components/appviews/home/home.component';
import { OnlyNumberDirective } from './components/common/only-number.directive';
import { QuestionComponent } from './components/appviews/Question/question/question.component';


@NgModule({
  declarations: [
    AppComponent,
    NavbarComponent,
    PreloaderComponent,
 
    FooterComponent,
   
    ChattingComponent,
    HomeComponent,
        QuestionComponent,
        OnlyNumberDirective
  ],
  imports: [
      BrowserModule, FormsModule, HttpClientModule, BsDatepickerModule, BrowserAnimationsModule, MatTableModule,
      ToastrModule.forRoot(),
      MatSortModule,
      MatPaginatorModule, MatChipsModule,
      AgmCoreModule.forRoot({
          apiKey: 'AIzaSyAfIzbiX48h8Hr0S4uX-YPQHQAeV3CRsWw'
      }),
    AppRoutingModule
  ],
    providers: [BsDatepickerConfig],
  bootstrap: [AppComponent]
})
export class AppModule { }
